import * as React from 'react';
import classnames from 'classnames';

import { Data, data } from './data';

import styles from './styles.module.css';

export interface ReferralStepsProps {
  className?: string;
}

/**
 * @name ReferralSteps
 * @description Introduction to our referrals program
 */
export const ReferralSteps = (props: ReferralStepsProps) => {
  const { className } = props;

  // Styles
  const cssComponent = classnames('flex flex-col', styles.steps, className);
  const cssStep = classnames('flex flex-col', styles.step);
  const cssStepCopy = classnames('flex gap-4x mt-4x', styles.stepCopy);

  // Markup
  const renderStep = (reward: Data, index: number) => {
    const { image, copy, subcopy } = reward;

    const classesCircle = classnames(styles.circle, {
      'bg-pine': index === 1,
      'bg-rust': index === 2,
      'bg-turmeric': index === 0
    });

    return (
      <div className={cssStep} key={image}>
        <img alt="" src={image} />
        <div className={cssStepCopy}>
          <div>
            <div className={classesCircle} />
          </div>
          <div>
            <h3
              className={styles.subhead}
              dangerouslySetInnerHTML={{ __html: copy }}
            />
            {subcopy && renderSubcopy(subcopy)}
          </div>
        </div>
      </div>
    );
  };

  const renderSubcopy = (text: string) => (
    <p className={styles.subcopy} dangerouslySetInnerHTML={{ __html: text }} />
  );

  return <div className={cssComponent}>{data.map(renderStep)}</div>;
};
